import { wcagContrastRatio, wcagContrastRatioThreshold } from "./a11yUtils";
// This is pulled from the embedded-theming defaults and should remain consistent with the fallback value in
// lib/express/config/command/get_default_express_dashboard_config.rb
export const EMBEDDED_DEFAULT_PRIMARY_COLOR = '#0074D4';
// For dark mode, in the case of inaccessible UI, we default to this color
export const EXPRESS_DEFAULT_PRIMARY_COLOR_DARK_MODE = '#E0E4EC';
// According to PRD https://docs.google.com/document/d/1sjUBBzwO3AWFozqmU7hyn5bXO_ZuLYnR-q3CJzIyxtk/edit?tab=t.1ntjjpc1kbt2
export const expressLightBaseTheme = {
    colorBackground: '#FFFFFF',
    colorText: '#373737',
    colorSecondaryText: '#717171',
    offsetBackgroundColor: '#F8F8F8',
    colorBorder: '#D7D7D7',
    overlayBackdropColor: 'rgba(0, 0, 0, 0.20)',
    buttonSecondaryColorBackground: '#EBEEF1',
    buttonSecondaryColorText: '#393B3E'
};
// According to PRD https://docs.google.com/document/d/1sjUBBzwO3AWFozqmU7hyn5bXO_ZuLYnR-q3CJzIyxtk/edit?tab=t.1ntjjpc1kbt2
export const expressDarkBaseTheme = {
    colorBackground: '#14171D',
    colorDanger: '#F23154',
    colorText: '#E0E4EC',
    colorSecondaryText: '#A2ADBD',
    offsetBackgroundColor: '#1B1E25',
    colorBorder: '#424851',
    overlayBackdropColor: 'rgba(40, 40, 40, 0.70)',
    buttonSecondaryColorBackground: '#373A3F',
    buttonSecondaryColorText: '#FFFFFF',
    badgeSuccessColorBackground: 'rgb(21, 34, 7)',
    badgeSuccessColorBorder: 'rgb(32, 54, 12)',
    badgeSuccessColorText: 'rgb(62, 174, 32)',
    badgeNeutralColorBackground: 'rgb(27, 30, 37)',
    badgeNeutralColorBorder: 'rgb(43, 48, 57)',
    badgeNeutralColorText: 'rgb(140, 153, 173)',
    badgeDangerColorBackground: 'rgb(66, 3, 32)',
    badgeDangerColorBorder: 'rgb(97, 9, 45)',
    badgeDangerColorText: 'rgb(244, 107, 125)',
    badgeWarningColorBackground: 'rgb(64, 10, 0)',
    badgeWarningColorBorder: 'rgb(95, 20, 0)',
    badgeWarningColorText: 'rgb(242, 116, 0)'
};
// TODO: Remove once embedded components support info badge appearance variables.
export const EXPRESS_DARK_MODE_INFO_BADGE_COLORS = {
    background: 'rgb(5, 26, 76)',
    border: 'rgb(9, 42, 112)',
    text: 'rgb(43, 157, 246)'
};
export const isColorPrimaryAccessible = (colorPrimary, backgroundColor)=>{
    return wcagContrastRatio(colorPrimary, backgroundColor) >= wcagContrastRatioThreshold.AALarge;
};
export const isPrimaryLinkColorDifferentFromText = (colorPrimary, colorText)=>{
    // WCAG also dictates that for non underlined links, the contrast ratio should be >=3.0. We choose a slightly more relaxed threshold of 2.5 to allow for a bit more flexibility in the colors that can be used
    return wcagContrastRatio(colorPrimary, colorText) >= 2.5;
};

//# sourceMappingURL=expressThemes.js.map